$(function () {
    const { renderCampaignGauge } = require('./campaign-gauge');
    const params = new URLSearchParams(window.location.search);

    if (params.has('register_id')) {
        params.delete('register_id');
        const query = params.toString();
        window.history.replaceState(
            null,
            '',
            `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`
        );
    }

    const $campaignsSection = $('#campaigns-active');

    if (!$campaignsSection.length) {
        return;
    }

    const $emptyState = $('#campaigns-empty');
    const $content = $('#campaigns-content');
    const $carouselWrapper = $('#campaigns-carousel-wrapper');
    const $grid = $('#campaigns-grid');
    const $detailsSection = $('#campaign-details');
    const $detailsContainer = $('#campaign-details-container');
    const desktopSlidesToShow = 3;
    const TITLE_MAX_LENGTH = parseInt($campaignsSection.data('title-max'), 10) || 60;
    const SUBTITLE_MAX_LENGTH = parseInt($campaignsSection.data('subtitle-max'), 10) || 100;

    const escapeHtml = function (value) {
        if (value === null || value === undefined) {
            return '';
        }

        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    const formatNumber = function (value) {
        return Math.round(Number(value) || 0).toLocaleString('pt-BR');
    };

    const truncateText = function (value, maxLength) {
        const text = value === null || value === undefined ? '' : String(value).trim();

        if (!text || text.length <= maxLength) {
            return text;
        }

        return text.slice(0, maxLength).trimEnd() + '…';
    };

    const renderCampaignCard = function (campaign) {
        const modifierClass = campaign.card_modifier_class ? ` ${escapeHtml(campaign.card_modifier_class)}` : '';
        const cardTitle = truncateText(campaign.title, TITLE_MAX_LENGTH);
        const cardSubtitle = campaign.subtitle
            ? truncateText(campaign.subtitle, SUBTITLE_MAX_LENGTH)
            : '';
        const titleAttr = campaign.title && campaign.title !== cardTitle
            ? ` title="${escapeHtml(campaign.title)}"`
            : '';
        const subtitle = cardSubtitle
            ? `<p class="campaign-card__subtitle"${campaign.subtitle !== cardSubtitle ? ` title="${escapeHtml(campaign.subtitle)}"` : ''}>${escapeHtml(cardSubtitle)}</p>`
            : '';
        const progress = campaign.progress
            ? `<div class="campaign-card__consultant-status">
                    <p class="campaign-card__progress-text">
                        <span class="campaign-card__label">Progresso:</span>
                        ${escapeHtml(campaign.progress)}
                    </p>
                </div>`
            : '';

        return ''
            + '<div class="campaigns-grid__item" role="listitem">'
            + `<article class="campaign-card${modifierClass}">`
            + '    <header class="campaign-card__header">'
            + `        <h3 class="campaign-card__title"${titleAttr}>${escapeHtml(cardTitle)}</h3>`
            + subtitle
            + '        <div class="campaign-card__header-badges">'
            + `            <span class="campaign-card__type ${escapeHtml(campaign.type_badge_class)}">`
            + `                ${escapeHtml(campaign.type_label)}`
            + '            </span>'
            + '        </div>'
            + '    </header>'
            + '    <div class="campaign-card__body">'
            + '        <p class="campaign-card__period">'
            + '            <span class="campaign-card__period-label">Período</span>'
            + `            <span class="campaign-card__period-value">${escapeHtml(campaign.period_formatted)}</span>`
            + '        </p>'
            + progress
            + '        <div class="campaign-card__divider" aria-hidden="true"></div>'
            + '        <div class="campaign-card__remaining">'
            + '            <span class="campaign-card__remaining-label">Tempo restante</span>'
            + `            <span class="campaign-card__remaining-value">${escapeHtml(campaign.remaining_time_text)}</span>`
            + '        </div>'
            + '    </div>'
            + '    <footer class="campaign-card__footer">'
            + `        <a href="#${escapeHtml(campaign.slug)}" class="campaign-card__cta js-campaign-detail"`
            + `           data-campaign-slug="${escapeHtml(campaign.slug)}"`
            + `           data-campaign-id="${campaign.id}">Ver detalhes</a>`
            + '    </footer>'
            + '</article>'
            + '</div>';
    };

    const renderCampaignDetail = function (campaign, fallbackUpdatedAt) {
        const detail = campaign.detail || {};
        const hasGoal = Number(detail.goal_value) > 0;
        const subtitle = campaign.subtitle
            ? `<p class="campaign-detail__subtitle">${escapeHtml(campaign.subtitle)}</p>`
            : '';
        const regulationBlock = campaign.regulation_public_url
            ? `<a href="${escapeHtml(campaign.regulation_public_url)}" class="campaign-detail__regulation-btn" target="_blank" rel="noopener" download>
                    CONSULTE O REGULAMENTO
                </a>`
            : '';
        const bannerBlock = campaign.banner_public_url
            ? `<div class="campaign-detail__banner">
                    <img src="${escapeHtml(campaign.banner_public_url)}" alt="Banner da campanha ${escapeHtml(campaign.title)}">
                </div>`
            : '';

        let dashboardBlock = '';
        const detailUpdatedAt = detail.last_updated_at || fallbackUpdatedAt;
        const updatedAtBlock = detailUpdatedAt
            ? `<p class="campaign-detail__updated-at">
                    <i class="far fa-calendar-alt" aria-hidden="true"></i>
                    Os dados são atualizados semanalmente — última atualização em ${escapeHtml(detailUpdatedAt)}
                </p>`
            : '';

        if (hasGoal) {
            const goalAttr = ` data-goal="${detail.goal_value}"`;
            const goalLabel = formatNumber(detail.goal_value);
            const scoreLabel = formatNumber(detail.user_score || 0);
            const userRank = detail.user_rank ? formatNumber(detail.user_rank) : '—';
            const totalParticipants = Number(detail.total_participants) || 0;
            const participantsLabel = totalParticipants === 1 ? 'participante' : 'participantes';

            dashboardBlock = ''
                + '    <div class="campaign-detail__dashboard">'
                + '        <div class="campaign-detail__panel campaign-detail__panel--performance">'
                + '            <div class="campaign-detail__panel-inner">'
                + '                <h3 class="campaign-detail__panel-title">Sua performance</h3>'
                + '                <div class="campaign-detail__panel-body">'
                + `                    <div class="campaign-gauge-wrap" role="img" aria-label="Pontuação acumulada ${scoreLabel}">`
                + '                        <div class="campaign-gauge-chart">'
                + `                            <canvas id="campaign-gauge-${campaign.id}" class="campaign-gauge-canvas"`
                + `                                    data-score="${detail.user_score || 0}"${goalAttr}`
                + '                                    aria-hidden="true"></canvas>'
                + '                            <span class="campaign-gauge-limit campaign-gauge-limit--min" aria-hidden="true">0</span>'
                + `                            <span class="campaign-gauge-limit campaign-gauge-limit--max" aria-hidden="true">${escapeHtml(goalLabel)}</span>`
                + `                            <p class="campaign-gauge-score" aria-hidden="true">${scoreLabel}</p>`
                + '                        </div>'
                + '                    </div>'
                + '                </div>'
                + '            </div>'
                + '        </div>'
                + '        <div class="campaign-detail__panel campaign-detail__panel--ranking">'
                + '            <div class="campaign-detail__panel-inner">'
                + '                <h3 class="campaign-detail__panel-title">Ranking Parcial</h3>'
                + '                <div class="campaign-detail__panel-body">'
                + '                    <div class="campaign-detail__ranking-visual">'
                + '                        <p class="campaign-detail__ranking-label">Sua posição está em</p>'
                + `                        <p class="campaign-detail__ranking-position">${userRank}</p>`
                + '                        <div class="campaign-detail__podium" aria-hidden="true">'
                + '                            <div class="campaign-detail__podium-step campaign-detail__podium-step--second"></div>'
                + '                            <div class="campaign-detail__podium-step campaign-detail__podium-step--first campaign-detail__podium-step--active"></div>'
                + '                            <div class="campaign-detail__podium-step campaign-detail__podium-step--third"></div>'
                + '                        </div>'
                + '                    </div>'
                + '                    <p class="campaign-detail__ranking-total">'
                + `                        de ${formatNumber(totalParticipants)} ${participantsLabel}`
                + '                    </p>'
                + '                </div>'
                + '            </div>'
                + '        </div>'
                + '    </div>';
        }

        return ''
            + `<article class="campaign-detail" id="campaign-${escapeHtml(campaign.slug)}"`
            + ` data-campaign-slug="${escapeHtml(campaign.slug)}"`
            + ` data-campaign-id="${campaign.id}"`
            + ` data-has-goal="${hasGoal ? '1' : '0'}" hidden`
            + ` aria-labelledby="campaign-detail-title-${escapeHtml(campaign.slug)}">`
            + '    <header class="campaign-detail__intro">'
            + `        <h2 class="campaign-detail__title" id="campaign-detail-title-${escapeHtml(campaign.slug)}">${escapeHtml(campaign.title)}</h2>`
            + subtitle
            + `        <p class="campaign-detail__period">${escapeHtml(campaign.period_formatted)}</p>`
            + '    </header>'
            + dashboardBlock
            + updatedAtBlock
            + regulationBlock
            + bannerBlock
            + '</article>';
    };

    const initCampaignsCarousel = function (totalCount) {
        if (totalCount <= desktopSlidesToShow) {
            return;
        }

        if (typeof $.fn.slick === 'undefined') {
            setTimeout(function () {
                initCampaignsCarousel(totalCount);
            }, 500);
            return;
        }

        if ($grid.hasClass('slick-initialized')) {
            $grid.slick('unslick');
        }

        const tabletSlidesToShow = 2;
        const hasDesktopOverflow = totalCount > desktopSlidesToShow;
        const hasTabletOverflow = totalCount > tabletSlidesToShow;
        const hasMobileOverflow = totalCount > 1;

        $grid.slick({
            dots: hasDesktopOverflow,
            arrows: false,
            infinite: false,
            speed: 500,
            slidesToShow: desktopSlidesToShow,
            slidesToScroll: 1,
            autoplay: false,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: tabletSlidesToShow,
                        slidesToScroll: 1,
                        dots: hasTabletOverflow
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: hasMobileOverflow,
                        edgeFriction: 0.9
                    }
                }
            ]
        });
    };

    const showCampaignDetail = function (campaignSlug) {
        if (!$detailsSection.length || !campaignSlug) {
            return;
        }

        $('.campaign-detail').attr('hidden', true);
        const $panel = $(`#campaign-${campaignSlug}`);

        if (!$panel.length) {
            return;
        }

        $panel.removeAttr('hidden');

        if (String($panel.data('has-goal')) === '1') {
            renderCampaignGauge($panel.data('campaign-id'));
        }

        $('.campaign-card').removeClass('campaign-card--selected');
        $(`.js-campaign-detail[data-campaign-slug="${campaignSlug}"]`)
            .closest('.campaign-card')
            .addClass('campaign-card--selected');

        $('html, body').animate({
            scrollTop: $detailsSection.offset().top - 24
        }, 600);

        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', `#${campaignSlug}`);
        } else {
            window.location.hash = campaignSlug;
        }
    };

    $(document).on('click', '.js-campaign-detail', function (event) {
        event.preventDefault();
        showCampaignDetail($(this).data('campaign-slug'));
    });

    $(document).on('click', '.js-campaign-share', function () {
        const $button = $(this);
        const shareUrl = $button.data('share-url');
        const shareTitle = $button.data('campaign-title');

        if (navigator.share) {
            navigator.share({
                title: shareTitle,
                url: shareUrl
            });
            return;
        }

        if (navigator.clipboard && shareUrl) {
            navigator.clipboard.writeText(shareUrl);
            return;
        }

        window.prompt('Copie o link da campanha:', shareUrl);
    });

    const renderCampaigns = function (payload) {
        const campaigns = Array.isArray(payload.campaigns) ? payload.campaigns : [];

        if (!campaigns.length) {
            $emptyState.removeClass('d-none');
            $content.addClass('d-none');
            $detailsSection.addClass('d-none');
            return;
        }

        const totalCount = campaigns.length;
        const isCarousel = totalCount > desktopSlidesToShow;

        $emptyState.addClass('d-none');
        $content.removeClass('d-none');
        $detailsSection.removeClass('d-none');

        $carouselWrapper
            .toggleClass('campaigns-carousel-wrapper--static', !isCarousel);
        $grid
            .removeClass('campaigns-carousel campaigns-grid--static')
            .addClass(isCarousel ? 'campaigns-carousel' : 'campaigns-grid--static')
            .attr('data-campaign-count', totalCount)
            .html(campaigns.map(renderCampaignCard).join(''));

        $detailsContainer.html(
            campaigns.map(function (campaign) {
                return renderCampaignDetail(campaign, payload.last_updated_at);
            }).join('')
        );

        if (isCarousel) {
            initCampaignsCarousel(totalCount);
        }

        const campaignSlug = window.location.hash.replace(/^#/, '');

        if (campaignSlug) {
            showCampaignDetail(campaignSlug);
        }
    };

    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('user_id');

    if (!token || !userId) {
        $emptyState.removeClass('d-none');
        return;
    }

    $.ajax({
        url: '/api/campaigns',
        method: 'GET',
        headers: Object.assign(
            {},
            window.$headerAuth || { Authorization: 'Bearer ' + token },
            { 'X-User-Id': userId }
        )
    }).done(function (payload) {
        renderCampaigns(payload);
    }).fail(function () {
        $emptyState.removeClass('d-none');
    });
});
